import { useAuth } from "@/hooks";
import { NormalStyles } from "@/layouts/styles/ssr.style";
import ModalReport from "@/modules/book-body/components/modal-report";
import { showModalForm, userInfo } from "@/redux/reducers/user.reducer";
import { AppDispatch } from "@/redux/store";
import commentAPI from "@/services/comment_api";
import { definitions } from "@/services/metruyenvl";
import reactionAPI from "@/services/reaction_api";
import reviewAPI from "@/services/review_api";
import { userActionAPI } from "@/services/user_action_api";
import { Constants, ResponseTypes } from "@/types/constants";
import { unixToDate } from "@/utils/formatted";
import { Avatar, Button, Rate } from "antd";
import Image from "next/image";
import ConfirmDeleteModal from "@/components/confirm-delete-modal";
import React, { useEffect, useState } from "react";
import { AiFillLike } from "react-icons/ai";
import { BiSolidShare, BiTimeFive } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { FaFlag, FaGlasses } from "react-icons/fa6";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/navigation";
import { statAPI } from "@/services/stat_api";
import { deleteReview } from "@/redux/reducers/book.reducer";
import { DeleteOutlined } from "@ant-design/icons";

function ReviewItem({ book, review }: { book: definitions["do.BookDO"]; review: definitions["do.ReviewDO"] }) {
    const router = useRouter();
    const { profile, isAuth } = useAuth();
    const dispatch = useDispatch<AppDispatch>();
    const [isVisible, setIsVisible] = useState<boolean>(false);
    const [statReview, setStatReview] = useState<definitions["do.StatsDO"]>({});
    const [actionUser, setActionUser] = useState<definitions["do.UserActionDO"]>({});

    const userData = useSelector(userInfo);

    const getMoreReview = async (reviewID: string) => {
        const res = await reviewAPI.getListReview(book.id, "", 1, 200);
        // console.log(res.data.data);
    };

    const getUserAction = async () => {
        try {
            const res: ResponseTypes = await userActionAPI.getUserAction("review", review.id as string);
            setActionUser(res.data);
        } catch (error) {
            console.log(error);
        }
    };

    const getStatsData = async () => {
        try {
            const res: ResponseTypes = await statAPI.getStat("review", review.id as string);
            setStatReview(res.data);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        if (!review.stats) {
            getStatsData();
        } else {
            setStatReview(review.stats);
        }
    }, []);

    useEffect(() => {
        if (isAuth) {
            getUserAction();
        }
    }, []);

    const likeReview = async (reviewID: string) => {
        try {
            const res = await reactionAPI.postReaction("review", reviewID, "like");
            setStatReview(res.data as definitions["do.StatsDO"]);
            // setStatReview(res.data);
            getMoreReview(reviewID);
            getUserAction();
        } catch (error) {
            console.log(error);
        }
    };

    const removeLike = async (reviewID: string) => {
        try {
            const res = await reactionAPI.postReaction("review", reviewID, "like");
            setStatReview(res.data as definitions["do.StatsDO"]);
            //   reload();
            getMoreReview(reviewID);
            getUserAction();
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className="mt-3 border-solid border-t border-slate-200 w-full flex pt-3 pr-3 gap-x-6">
            <ConfirmDeleteModal
                title="Bạn có muốn xoá đánh giá này không?"
                cancelCallback={() => {
                    setIsVisible(false);
                }}
                confirmCallback={() => {
                    dispatch(deleteReview({ bookID: book.id as string, reviewID: review.id as string }));
                    setIsVisible(false);
                }}
                isVisible={isVisible}
            />
            <div>
                <Avatar size={60} icon={<Image unoptimized={true} height={60} width={60} src={review?.author?.avatar ?? "/avatar.gif"} alt="" />} />
            </div>
            <div className="w-full">
                <div className="w-full flex items-center justify-between">
                    <div
                        className="cursor-pointer text-blue-600 font-semibold text-lg "
                        onClick={() => {
                            router.push(`/ho-so/${review.author?.id}`);
                        }}
                    >
                        {review?.author?.name ?? Constants.DefaultUserName}
                    </div>
                    {profile.id === review.user_id && (
                        <Button
                            type="text"
                            size="large"
                            style={{ color: "red" }}
                            icon={<DeleteOutlined />}
                            loading={isVisible}
                            onClick={() => {
                                setIsVisible(true);
                            }}
                        />
                    )}
                </div>
                <Rate className="mb-1 text-xs" disabled allowHalf value={review?.score} />
                <div className="flex gap-x-4 items-center mb-2">
                    <div className="flex items-center gap-x-2 text-sm">
                        {" "}
                        <BiTimeFive size={10} />
                        <div className="text-gray-500" style={{ fontSize: "10px" }}>
                            {unixToDate(review?.created_time ?? 0)}
                        </div>
                    </div>
                    <div className="flex items-center gap-x-2">
                        {" "}
                        <FaGlasses size={10} />
                        <div
                            className="text-gray-500 cursor-pointer"
                            style={{ fontSize: "10px" }}
                            onClick={() => {
                                router.push(`/truyen/${book.slug}/${review.author_chapter_reading?.slug}`);
                            }}
                        >
                            {review?.author_chapter_reading?.title ? `Đang đọc: ${review?.author_chapter_reading?.title}` : "Chưa đọc chương nào"}
                        </div>
                    </div>
                </div>
                <div style={{ fontSize: "18px" }}>{review.content}</div>
                {review?.stats?.comments_count && (
                    <div
                        className="font-semibold cursor-pointer"
                        onClick={() => {
                            getMoreReview(review.id as string);
                        }}
                    >
                        Xem thêm {review?.stats?.comments_count ?? 0} bình luận
                    </div>
                )}
                <div className="flex items-center gap-x-6 text-slate-400 float-right cursor-pointer">
                    <div
                        className="flex items-center gap-x-1"
                        onClick={() => {
                            if (isAuth) {
                                console.log("Action like review need implement");
                                // review.is_like ? removeLike(item.id) : likeReview(item.id);
                            } else {
                                dispatch(showModalForm(true));
                            }
                        }}
                    >
                        <AiFillLike size={14} color={actionUser.reaction_used === "like" ? "blue" : "rgb(148 163 184)"} /> {!!statReview.reacts_count ? statReview.reacts_count : statReview.reacts_count ?? 0}
                    </div>
                    {/* <div
                        className="flex items-center gap-x-1"
                        onClick={() => {
                            //   setReply({
                            //     id: item.id,
                            //     open: true,
                            //   });
                        }}
                    >
                        <BiSolidShare size={24} />
                        Trả lời
                    </div> */}
                    <ModalReport />
                    {/* <div className="flex items-center gap-x-1">
                        <FaFlag size={18} /> Báo xấu
                    </div> */}
                </div>
            </div>
        </div>
    );
}

export default ReviewItem;
